import {Combobox, ComboboxLabel, ComboboxOption} from "@/components/tailwind/combobox.tsx";
import {MobilityOption} from "@/models/mobility-option.ts";
import {Text} from "@/components/tailwind/text.tsx";
import {FieldLabel} from "@/components/field-label.tsx";

type MobilityOptionSelection = {
    id: string;
    name: string;
}

type MobilityOptionComboboxProps = {
    value: MobilityOptionSelection | null;
    onChange: (value: MobilityOptionSelection | null) => void;
    options: MobilityOption[];
    label: string;
    disabled?: boolean;
    'data-testid'?: string;
}

export function MobilityOptionCombobox({
    value,
    onChange,
    options,
    label,
    disabled = false,
    'data-testid': dataTestId
}: MobilityOptionComboboxProps) {
    // Convert MobilityOption[] to MobilityOptionSelection[] by picking only needed fields
    const selectionOptions: MobilityOptionSelection[] = options.map(option => ({
        id: option.id,
        name: option.name
    }));

    const sortedOptions = [...selectionOptions].sort((a, b) => a.name.localeCompare(b.name));

    return (
        <div data-testid={dataTestId}>
            <FieldLabel>
                <Text>{label}</Text>
            </FieldLabel>
            <div className="mt-2">
                <Combobox
                    value={value ?? undefined}
                    onChange={(newValue) => onChange(newValue ?? null)}
                    disabled={disabled}
                    options={sortedOptions}
                    displayValue={(option: MobilityOptionSelection | null) => option?.name ?? ''}
                    filter={(option: MobilityOptionSelection, query: string) =>
                        option.name.toLowerCase().includes(query.toLowerCase())
                    }
                    placeholder="--"
                >
                    {(option) => (
                        <ComboboxOption value={option}>
                            <ComboboxLabel>{option.name}</ComboboxLabel>
                        </ComboboxOption>
                    )}
                </Combobox>
            </div>
        </div>
    );
}
